import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import styled from "styled-components";
import { useState, useEffect } from "react";

export const Root = () => {
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <div>
      <StyledRoot>
        <Body>
          <HomePage />
        </Body>
      </StyledRoot>
      <Footer />
    </div>
  );
};

const StyledRoot = styled.div({
  display: "flex",
  justifyContent: "center",
});

const Body = styled.div({
  // backgroundColor: "lightGrey",
  // padding: "50px 0px",
  width: "100%",
  maxWidth: "800px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
